import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useUser } from "../../contexts/user";
import { Helmet } from "react-helmet";
import Loader from "../loader/loader";
import { hasDashboardPermission } from "../../utils";

type Props = {
  title: string;
  exact: boolean;
  path: any;
  component: React.FC;
};

const AdminPage: React.FC<Props> = ({ title, exact, path, component }) => {
  const [user] = useUser();

  return (
    <Loader full loading={!user || user.user?.id === ""}>
      <Helmet>
        <title>{title || "Pixlip"}</title>
      </Helmet>
      {user &&
      user.order.id !== "guest" &&
      hasDashboardPermission(user?.user) ? (
        <Route exact={exact} path={path} component={component} />
      ) : (
        <Redirect to="/login" />
      )}
    </Loader>
  );
};

export default AdminPage;
